module.exports = __webpack_public_path__ + "static/media/n-53-shot-2.3a5ff544.webp";